// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Component } from 'react';
// Base React component with update state logic
export class WMComponent extends Component {
    constructor(props, ViewModel) {
        super(props);
        this.onAddItem = this.onAddItem.bind(this);
        this.onRemoveItem = this.onRemoveItem.bind(this);
        this.onUpdateItem = this.onUpdateItem.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.viewModel = new ViewModel();
        this.state = Object.assign({}, this.viewModel.componentView);
    }
    componentDidMount() {
        this.viewModel.subscribeToAddItem(this.onAddItem);
        this.viewModel.subscribeToRemoveItem(this.onRemoveItem);
        this.viewModel.subscribeToUpdateItem(this.onUpdateItem);
        this.viewModel.subscribeToUpdate(this.onUpdate);
        this.viewModel.initialize(this.props);
    }
    componentWillUnmount() {
        this.viewModel.unsubscribeFromAddItem(this.onAddItem);
        this.viewModel.unsubscribeFromRemoveItem(this.onRemoveItem);
        this.viewModel.unsubscribeFromUpdateItem(this.onUpdateItem);
        this.viewModel.unsubscribeFromUpdate(this.onUpdate);
        this.viewModel.dispose();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.viewModel.update(this.props, prevProps);
    }
    onAddItem(key, value, index) {
        this.setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), { key: [...prevState[key].slice(0, index), value, ...prevState[key].slice(index)] });
        });
    }
    onRemoveItem(key, value, index) {
        this.setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), { key: prevState[key].filter((item, i) => i !== index) });
        });
    }
    onUpdateItem(key, value, index) {
        this.setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), { key: prevState[key].map((item, i) => (i === index ? value : item)) });
        });
    }
    onUpdate(key, value) {
        const updatedData = {};
        updatedData[key] = value;
        this.setState(updatedData);
    }
}
